<template>
  <div class="flex min-h-screen flex-col justify-center px-6 py-12 lg:px-8 bg-gradient-to-br from-red-600 to-indigo-600">
    <LmComponentLoading v-if="isLoading" fixed />
    <div class="full-alert">
      <div class="message w-50 text-center">
        <section v-if="emailWasConfirmed">
          <i class="w-50 mdi mdi-check-circle-outline"></i>
          <h3>Email confirmado</h3>
          <a-button ghost @click="$router.push('/')">{{$t('continue')}}</a-button>
        </section>
        <section v-else>
          <i class="mdi mdi-close-circle-outline"></i>
          <h3>Oops no pudimos validar tu email</h3>
          <a-button ghost @click="$router.push('/')">{{$t('try_again')}}</a-button>
        </section>
        <p>
          <!-- ¿Sabías que gestionando tus documentos de forma digital contribuis a reducir la deforestación y ahorrar agua? -->
        </p>
        <p>
          <!-- <b-link href="https://lumbredocs.com.ar" target="_blank" class="lm-link">Obtené mas información</b-link> -->
        </p>
        <div class="mt-4">
          <img :src="$store.state.settings.logoHomeImg" height="30px" alt="Logo" class="py-2">
        </div>
      </div>
    </div>
    <div class="full-alert danger" v-if="tokenExpiredFeedback">
      <div class="message w-50 text-center">
        <i class="mdi mdi-block-helper"></i>
        <h3>El Enlace Expiró</h3>
        <p>¿Sabías que gestionando tus documentos de forma digital contribuis a reducir la deforestación y ahorrar agua? <b-link href="https://lumbredocs.com.ar" target="_blank" class="lm-link">Obtené mas información</b-link></p>
        <div class="mt-4">
          <img :src="$store.state.settings.logoHomeImg" height="30px" alt="Logo" class="py-2">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Components
import LmButton from '@/components/form/elements/LmButton'
import LmFooter from '@/components/LmFooter'
import commonsApi from '@/api/commons'

// Utils
import lmToasts from '@/mixins/lmToasts.js'

export default {
  mixins: [lmToasts],
  components: {
    LmButton,
    LmFooter
  },
  data () {
    return {
      isAcctionProcessing: false,
      isLoading: false,
      emailWasConfirmed: false
    }
  },
  computed: {
  },
  methods: {
    setToken (data) {
      this.otpToken = data.comment
    },
    async activateLocation () {
      await this.init()
    },
    getLocation () {
      return new Promise((resolve, reject) => {
        const options = {
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0
        }

        navigator.geolocation.getCurrentPosition(
          (position) => resolve({
            timestamp: position.timestamp,
            accuracy: position.coords.accuracy,
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          }),
          // (error) => reject(error),
          (error) => {
            console.log(error)
            resolve()
          },
          options
        )
      })
    },
    async init () {
      try {
        this.isLoading = true
        this.location = await this.getLocation()
        await commonsApi.axiosPostWrapper('/users/validate-my-email', {
          token: this.$route.params.token,
          location: this.location
        })
        this.emailWasConfirmed = true
      } catch (error) {
        if (error.code === 1) {
          this.locationMessageFeedback = true
        }
        if (error?.response?.data?.message?.name === 'TokenExpiredError') {
          this.tokenExpiredFeedback = true
        }
      } finally {
        this.isLoading = false
      }
    }
  },
  async created () {
    await this.init()
  }
}
</script>

<style scoped>
.logo-img {
  max-width: 200px;
  max-height: 50px;
}

.document-signed-alert {
  color: white;
  border-radius: 7px;
  padding: 0.4rem 1rem;
}

.document-signed-alert > i {
  font-size: 1rem;
}

.full-alert {
  color: white;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.full-alert.danger {
  background: rgb(210,60,1);
  background: linear-gradient(90deg, rgba(210,60,1,1) 0%, rgba(210,0,96,1) 100%);
}

.full-alert .lm-link {
  display: inline;
  background: transparent;
  color: white;
  border: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.4);
}

.full-alert .lm-button {
  min-width: 200px;
  text-transform: uppercase;
  background-color: white;
  color: black;
  border-radius: 20px;
  border: none;
  padding: 8px 20px;
  font-weight: bold;
  transition: all 0.4s ease-in-out;
}

.full-alert .lm-button:disabled {
  cursor: not-allowed;
  background-color: rgba(232, 232, 232, 0.9);
}

.full-alert .lm-button:disabled:hover {
  transform: scale(1);
  box-shadow: none;
}

.full-alert .lm-button:hover {
  transform: scale(1.02);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.full-alert .lm-button .lm-button-loading::before {
  font-weight: bold;
  animation-name: spin;
  animation-duration: 1000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

.full-alert .message > p {
  font-size: 1rem;
}

.full-alert .message > section > i {
  font-size: 4.4rem;
}

.full-alert .close-btn {
  font-size: 2rem;
  cursor: pointer;
  position: fixed;
  top: 30px;
  right: 30px;
  transition: ease-in-out 0.4s all;
}

.full-alert .close-btn:hover {
  transform: scale(1.2);
}
</style>
